import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Divider,
} from "@nextui-org/react";

import { FaClipboardQuestion } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { MdDelete } from "react-icons/md";

import { useDeleteLectureItem } from "../hooks/useDeleteLectureItem";
import UpdateLectureItem from "./UpdateLectureItem";

import Button from "@/components/Button";
import Modal from "@/components/Modal";
import ConfirmDelete from "@/components/ConfirmDelete";
import usePermission from "../../../../hooks/usePermission";

function QuizCard({ quizItem }) {
    const { can } = usePermission();

    const { courseId, lectureId } = useParams();

    const {
        name,
        brief,
        type,
        quizDuration,
        quizSuccessPercentage,
        quizAttemptLimit,
    } = quizItem.attributes;
    const { id } = quizItem;

    const { deleteLectureItem, isDeleting } = useDeleteLectureItem();

    return (
        <>
            <Card className="w-[298px] h-[275px] pt-3">
                <CardHeader className="flex items-center justify-between">
                    <div className="flex gap-3">
                        <FaClipboardQuestion className="text-4xl text-cyan-500" />
                        <div className="flex flex-col">
                            <p className="text-sm">{name}</p>
                            <p className="text-small text-default-500">
                                إختبار
                            </p>
                        </div>
                    </div>
                    {/* Modal For Delete Video */}
                    {can("delete:course:lecture:items") && (
                        <Modal>
                            <Modal.Open opens={`delete-${id}`}>
                                <button>
                                    <MdDelete className="text-3xl transition-all duration-300 text-red-color-primary hover:text-red-900" />
                                </button>
                            </Modal.Open>
                            <Modal.Window name={`delete-${id}`}>
                                <ConfirmDelete
                                    resourceName={name}
                                    disabled={isDeleting}
                                    onConfirm={() =>
                                        deleteLectureItem({
                                            courseId,
                                            lectureId,
                                            itemId: id,
                                        })
                                    }
                                />
                            </Modal.Window>
                        </Modal>
                    )}
                </CardHeader>

                <Divider />

                <CardBody className="text-right">
                    <>
                        <div className="flex items-center gap-5 pb-3">
                            <p>
                                مدة الأختبار :
                                <span className="px-1 text-gray-color-primary">
                                    {quizDuration}
                                </span>
                            </p>
                        </div>
                        <div className="flex items-center gap-5 pb-3">
                            <p>
                                نسبة النجاح في الأختبار :
                                <span className="px-1 text-gray-color-primary">
                                    {quizSuccessPercentage}
                                </span>
                            </p>
                        </div>
                        <div className="flex items-center gap-5 pb-3">
                            <p>
                                عدد مرات دخول الأمتحان:
                                <span className="px-1 text-gray-color-primary">
                                    {quizAttemptLimit === null || undefined
                                        ? " غير محددة "
                                        : quizAttemptLimit}
                                </span>
                            </p>
                        </div>
                    </>
                </CardBody>

                <CardFooter className="justify-between">
                    <Modal>
                        {/* Modal For Update Quiz */}
                        {can("update:course:lecture:items") && (
                            <>
                                <Modal.Open opens={`update-${id}`}>
                                    <Button
                                        type="primary"
                                        className="text-sm w-fit"
                                    >
                                        تعديل
                                    </Button>
                                </Modal.Open>

                                <Modal.Window name={`update-${id}`}>
                                    <UpdateLectureItem
                                        courseId={courseId}
                                        lectureId={lectureId}
                                        itemId={id}
                                        name={name}
                                        brief={brief}
                                        type={type}
                                        quizDuration={quizDuration}
                                        quizSuccessPercentage={
                                            quizSuccessPercentage
                                        }
                                        quizAttemptLimit={quizAttemptLimit}
                                    />
                                </Modal.Window>
                            </>
                        )}

                        {/* Modal For Put Quiz Quesions */}
                        <Modal.Open opens={`putQuestions-${id}`}>
                            <Button
                                type="primary"
                                className="text-sm w-fit"
                                to={`/admin/courses/${courseId}/lectures/${lectureId}/items/${id}`}
                            >
                                تفاصيل الأمتحان
                            </Button>
                        </Modal.Open>

                        <Modal.Window
                            name={`putQuestions-${id}`}
                        ></Modal.Window>
                    </Modal>
                </CardFooter>
            </Card>
        </>
    );
}

export default QuizCard;
